import React from "react";
import { Icon } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";
import WelcomeMessage from "./WelcomeMessage";
interface BaseProps {
  modalID: string;
  onClose: () => void;
  welcomeMessageIsVisible: boolean;
}
const InitalContent = () => {
  const undoScreenReaderOnlyClasses = "lm:static lm:w-auto lm:h-auto lm:overflow-visible lm:clip-auto lm:whitespace-normal lm:p-0 lm:m-0";
  return <>
      {/* mobile */}
      <div className="visible lm:invisible lm:h-0">
        <figure data-testid="modalImage">
          <source media="(min-width: 980px)" srcSet="//cdnimg.webstaurantstore.com/uploads/design/2024/6/PlusPage/plus-marketing-benefits-v2.svg" />
          <img src="//cdnimg.webstaurantstore.com/uploads/design/2024/6/PlusPage/plus-marketing-benefits-v2.svg" alt="" />
          <figcaption className="sr-only" data-sentry-element="figcaption" data-sentry-source-file="Header.tsx">
            <h2>Webstaurant Plus</h2>
            <p>
              Unlimited free shipping, expedited order processing, and a savings
              guarantee. All for just $99/month.
            </p>
            <p>Free Shipping</p>
            <p>Guaranteed Savings</p>
            <p>Get your items faster</p>
          </figcaption>
        </figure>
      </div>

      {/* desktop */}
      <div className="lm:visible invisible h-0 lm:flex flex-col">
        <figure data-testid="modalImage" className="m-0 mb-5">
          <source media="(min-width: 980px)" srcSet="//cdnimg.webstaurantstore.com/uploads/design/2024/6/PlusPage/plus-marketing-testimonial-image-v2.png" />
          <img src="//cdnimg.webstaurantstore.com/uploads/design/2024/6/PlusPage/plus-marketing-testimonial-image-v2.png" alt="" />
          <figcaption className="sr-only" data-sentry-element="figcaption" data-sentry-source-file="Header.tsx">
            <h2>Webstaurant Plus</h2>
            <p>
              Unlimited free shipping, expedited order processing, and a savings
              guarantee. All for just $99/month.
            </p>
            <blockquote>
              “The Plus program is saving us a ton of money. At $99 a month, it
              paid for itself in literally the first week we had it.”
            </blockquote>
            <cite>— John S. of John Serock Catering</cite>
          </figcaption>
        </figure>

        <p className={`sr-only ${undoScreenReaderOnlyClasses} text-xs font-normal text-blue-50 pt-6`}>
          Special offers only valid for first time subscribers. This program
          only allows for a single shipping address and may be updated once per
          payment cycle if benefit is unused. Enrollment is open only to
          addresses located in the 48 contiguous United States. WebstaurantStore
          reserves the right to modify the terms of this program and to cancel
          this program at any time.
        </p>
      </div>
    </>;
};
const Header = ({
  onClose,
  welcomeMessageIsVisible,
  modalID
}: BaseProps) => {
  return <>
      <button aria-label="Close" className="fixed z-20 right-4 top-4 appearance-none bg-transparent border-none m-0 p-0 rounded opacity-100 hover:opacity-50 lm:font-normal" data-testid="closeButton" onClick={onClose} type="button">
        <Icon className="fill-white" name="ri-close-line" size="small" theme="wss" data-sentry-element="Icon" data-sentry-source-file="Header.tsx" />
      </button>

      <div className={cls("bg-[#022E44] flex overflow-hidden relative", "lm:p-0 lm:border-b-0 lm:static lm:h-full", !welcomeMessageIsVisible && "p-10 lm:px-12 lm:pb-6 lm:pt-8", welcomeMessageIsVisible && "absolute inset-0 z-10")}>
        <div className={cls("relative w-full h-full", welcomeMessageIsVisible && "w-full align-center")}>
          <div className={cls("w-full h-full", welcomeMessageIsVisible ? "opacity-0 pointer-events-none" : "opacity-100")}>
            <InitalContent data-sentry-element="InitalContent" data-sentry-source-file="Header.tsx" />
          </div>
          {/* this transition handles the opacity transistion (not the left to right transition) */}
          <div className={cls("opacity-0 transition-opacity duration-[300ms] delay-[450ms] ease-in-out", welcomeMessageIsVisible && "opacity-100")}>
            {/* This animation handles the scaling in, with different timing than opacity.
             Tailwind doesn't support stacking animations with
             different timing/duration so - we need this extra div to do that */}
            <div className={cls("absolute inset-0 w-full h-full pointer-events-none", "transition-transform transform origin-center delay-[300ms] duration-[500ms] scale-[0.4]", welcomeMessageIsVisible && "flex justify-center items-center scale-100 pointer-events-auto")}>
              <WelcomeMessage modalID={modalID} onClose={onClose} welcomeMessageIsVisible={welcomeMessageIsVisible} data-sentry-element="WelcomeMessage" data-sentry-source-file="Header.tsx" />
            </div>
          </div>
        </div>
      </div>
    </>;
};
export default Header;